module.exports = __webpack_public_path__ + "res/20-img_game_bg_m.0c16f18b7c1cf0a5d6d4a02095c0b818.png";